import { useEffect } from 'react';

/**
 * Posts the chosen logo into the preview iframes so the rendered casino reflects
 * the owner's selection. Ported from the Deploy module's `useIframe`: it targets
 * the `#secondary-desktop` / `#secondary-mobile` iframes (which we render in the
 * device mockups) and `postMessage`s an `UPDATE_LOGOS` payload on load + on change.
 */
export function useLogoIframe(logoUrl: string | null): void {
  useEffect(() => {
    const selectors = ['iframe#secondary-desktop', 'iframe#secondary-mobile'];

    const post = (el: HTMLIFrameElement): void => {
      if (!el.contentWindow || !logoUrl) return;
      el.contentWindow.postMessage(
        {
          type: 'UPDATE_LOGOS',
          payload: {
            footer: { src: logoUrl },
            onboarding: { src: logoUrl },
            topNavDesktop: { src: logoUrl },
            topNavMobile: { src: logoUrl },
          },
        },
        el.src,
      );
    };

    const onLoad = (e: Event): void => post(e.target as HTMLIFrameElement);

    const els = selectors
      .map((s) => document.querySelector<HTMLIFrameElement>(s))
      .filter((el): el is HTMLIFrameElement => el !== null);

    els.forEach((el) => {
      el.addEventListener('load', onLoad);
      post(el);
    });

    return () => els.forEach((el) => el.removeEventListener('load', onLoad));
  }, [logoUrl]);
}